module.exports = __webpack_public_path__ + "img/slovakia.60d59f4b.svg";